/**
 * Arte generado (IA) que se suelta en src/assets/art/… con el id como nombre de archivo:
 *   cards/<cardId>.webp      wonders/<wonderId>_<day|night>.webp      ui/<nombre>.webp
 * Si falta un archivo, los componentes usan el arte procedural de reserva.
 */
const cards = import.meta.glob<string>('./art/cards/*.webp', { eager: true, query: '?url', import: 'default' });
const wonders = import.meta.glob<string>('./art/wonders/*.webp', { eager: true, query: '?url', import: 'default' });
const ui = import.meta.glob<string>('./art/ui/*.webp', { eager: true, query: '?url', import: 'default' });

export const cardArtUrl = (defId: string): string | null => cards[`./art/cards/${defId}.webp`] ?? null;
export const wonderArtUrl = (id: string, side: 'day' | 'night'): string | null =>
  wonders[`./art/wonders/${id}_${side}.webp`] ?? null;
export const uiArtUrl = (name: string): string | null => ui[`./art/ui/${name}.webp`] ?? null;

export const artCoverage = () => ({ cards: Object.keys(cards).length, wonders: Object.keys(wonders).length, ui: Object.keys(ui).length });
